import DefaultLink, { LinkProps as DefaultLinkProps } from 'next/link';
import React from 'react';
import { useClient } from 'ui-hooks/useClient';
import { DirittoAppBridge } from 'libs/DirittoAppBridge';

export interface LinkProps extends DefaultLinkProps {
  className?: string;
  children?: React.ReactNode;
  rel?: string;
  href: string;
  title?: string;
}

export const ExternalLink = ({ className, children, href, title, rel, ...rest }: LinkProps) => {
  const client = useClient();
  if (client.isApp) {
    return (
      <button type="button" className={className} onClick={() => DirittoAppBridge.openExternalView(href, title)}>
        {children}
      </button>
    );
  }

  return (
    <DefaultLink {...rest} href={href} passHref className={className} target="_blank" rel={rel}>
      {children}
    </DefaultLink>
  );
};
